import ElementAdapter from '@javascripts/adapters/element_adapter';
import UserSession from '@javascripts/utils/user_session';

export default class UserIdWatermark {
  constructor(options = {}) {
    this._tech = options.tech;
    this._videoId = options.videoId;
    this._rawWatermarkData = options.rawWatermarkData;
    this._watermarkDuration = 90000;
    this._watermarkElement = null;
    this._watermarkAppended = false;
  }

  tech() {
    return this._tech;
  }

  videoId() {
    return this._videoId;
  }

  rawWatermarkData() {
    return this._rawWatermarkData;
  }

  watermarkDuration() {
    return this._watermarkDuration;
  }

  watermarkElement() {
    return this._watermarkElement;
  }

  now() {
    return Date.now();
  }

  init() {
    this.run(this.getWatermarkData());
  }

  getWatermarkData() {
    let watermarkData;
    try {
      watermarkData = JSON.parse(this.rawWatermarkData())
        .filter(data => data.id == this.videoId())[0] || null;
    } catch(e) {
      watermarkData = null;
    }
    return watermarkData;
  }

  createWatermark() {
    const element = document.createElement('div');
    let fullscreen_css = document.querySelector(".vjs-fullscreen") ? "font-size: 36px;" : ""
    element.innerHTML = `
      <div style="width: 100%; font-size: 20px; pointer-events: none; transition: ease all 1s; letter-spacing: 7px; text-shadow: 1px 1px black, -1px -1px black, -1px 1px black, 1px -1px black; ${fullscreen_css}">
        <span style="position: absolute; top: 30%; opacity: 0.3; left: 15%;">${UserSession.userId()}</span>
        <span style="position: absolute; top: 30%; opacity: 0.3; right: 15%;">${UserSession.userId()}</span>
      </div>
    `;

    this._watermarkElement = element.children[0];
    return element.children[0];
  }

  appendWatermark() {
    if (!this._watermarkAppended) {
      this.tech().videoComponentWrapper().appendChild(this.createWatermark());
      this._watermarkAppended = true;
    }
  }

  run(watermarkData) {
    if(watermarkData == null) return;
    if(!Array.isArray(watermarkData.time)) return;

    let duration = parseInt(watermarkData.duration);
    if(duration) this._watermarkDuration = duration * 1000;

    watermarkData.time.forEach(data => {
      this.processWatermark(data);
    });
  }

  processWatermark(time) {
    const now = this.now();
    const unixTime = new Date(time).getTime();

    if (now < unixTime) this.toggleWatermarkAfter(unixTime - now);
  }

  showWatermark() {
    if (UserSession.userId() !== undefined) {
      this.appendWatermark();
    }
  }

  hideWatermark() {
    this._watermarkAppended = false;
    this.tech().videoComponentWrapper().removeChild(this.watermarkElement());
  }

  toggleWatermark(duration = this.watermarkDuration()) {
    this.showWatermark();
    setTimeout(() => {
      this.hideWatermark();
    }, duration);
  }

  toggleWatermarkAfter(miliseconds) {
    setTimeout(() => {
      this.toggleWatermark();
    }, miliseconds);
  }
}
